import Crud from '../views/Company/Crud'
import Entity from '../views/Company/Add'

let routes = {
    path: '/companies',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/companies/add',
            name: 'NewCompany',
            component: Entity,
            meta: {
                perfil_id: ['1'] // Apenas administradores
            }
        },
        {
            path: '/companies/edit/:id?',
            name: 'EditCompany',
            component: Entity,
            meta: {
                perfil_id: ['1'] // Apenas administradores
            }
        },
        {
            path: '/companies',
            name: 'list-companies',
            component: Crud,
            meta: {
                pageTitle: 'Lista de Empresas',
                breadcrumb: [
                    {
                        text: 'Empresas',
                        active: true,
                    },
                ],
                perfil_id: ['1'] // Apenas administradores
            },
        },
    ]
};


export default routes
